import { render } from "./CardContent.vue?vue&type=template&id=45551d8a&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=js"
export * from "./CardContent.vue?vue&type=script&lang=js"

import "./CardContent.vue?vue&type=style&index=0&id=45551d8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45551d8a"]])

export default __exports__